module.exports = __webpack_public_path__ + "static/img/主图.f10ed16.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/match_result/figure/7/主图.png
// module id = C77D
// module chunks = 1